module.exports = __webpack_public_path__ + "static/img/banner5.9e7aabb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serve/banner5.jpg
// module id = 0NPJ
// module chunks = 0